'use client';

import { useWavespeedCatalog } from '@/hooks/useWavespeedCatalog';
import type { WavespeedModel } from '@/lib/ai/wavespeed';

export interface UseGenerationModelsResult {
  models: WavespeedModel[];
  getModel(id: string): WavespeedModel | undefined;
  ready: boolean;
}

export function useGenerationModels(): UseGenerationModelsResult {
  const { models, loading } = useWavespeedCatalog();
  return {
    models,
    getModel: (id) => {
      const model = models.find((m) => m.id === id || Object.values(m.variants ?? {}).includes(id));
      return model && { ...model, id, schema: model.variantSchemas?.[id] ?? model.schema };
    },
    ready: !loading,
  };
}
